import { useState, useEffect, useRef, useCallback } from "react";

export function useScrollSave(key: string, dataToSave: any, hasDataLoaded: boolean | undefined | null) {
  const [restoredData, setRestoredData] = useState<any>(null);
  const scrollYRef = useRef(0);
  const isRestored = useRef(false);
  const [shouldRestoreScroll, setShouldRestoreScroll] = useState<number | null>(null);

  useEffect(() => {
    const saved = sessionStorage.getItem(key);
    if (saved) {
      const parsed = JSON.parse(saved);
      setRestoredData(parsed);
      setShouldRestoreScroll(parsed.scrollY);
      scrollYRef.current = parsed.scrollY;
      isRestored.current = true;
    }
  }, [key]);

  useEffect(() => {
    if (shouldRestoreScroll !== null && hasDataLoaded) {
      const timer = setTimeout(() => {
        const el = document.getElementById('scrollable-content');
        if (el) {
          el.scrollTop = shouldRestoreScroll;
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [hasDataLoaded, shouldRestoreScroll]);

  useEffect(() => {
    const handleSave = () => {
      sessionStorage.setItem(key, JSON.stringify({
        ...dataToSave,
        scrollY: scrollYRef.current
      }));
    };
    return () => handleSave();
  }, [key, dataToSave]);

  const updateScrollY = useCallback((e: any) => {
    scrollYRef.current = e.target.scrollTop;
  }, []);

  return { restoredData, isRestored, updateScrollY };
}
